<template>
	<div class="file-list-view">
		<div class="file" v-for="(file, i) in value" v-bind:key="i" @click="open(file.id)">
			{{ file.label }}
			<div>
				<div @click.stop="attach(file)">Vedhæft</div>
				<div @click.stop="rename(file)">Omdøb</div>
				<div @click.stop="del(i)">Slet</div>
			</div>
		</div>
		<div v-if="value.length > 0" class="btn" @click="attachAll">Vedhæft alle</div>
		<div class="btn" @click="select">Upload</div>
		<input type="file" ref="file" @change="change" multiple />
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			del(i) {
				this.value.splice(i, 1);
			},
			rename(file) {
				var name = prompt('Navn', file.label);

				if (name == '') return;

				file.label = name;
			},
			select() {
				this.$refs.file.click();
			},
			change(e) {
				

				this.upload(e);
			},
			upload(e) {
				

				var self = this;

				var formData = new FormData();

				for (var i = 0; i < e.target.files.length; ++i) {
					formData.append('files[]', e.target.files[i]);
				}

				this.axios
					.post('/storage/all/', formData)
					.then(function (r) {
						

						for (var i = 0; i < r.data.length; ++i) {
							self.value.push({
								id: r.data[i],
								label: 'Ny fil - ' + (new Date()).format('Y-m-d') + ' - ' + (i + 1)
							});
						}
					});
			},
			open(file) {
				this.axios
					.get('/storage/urls/' + file + '/')
					.then(function (r) {
						

						window.open(r.data, '_blank');
					});
			},
			attach(file) {
				
				this.$store.state.attachments.push(file);
			},
			attachAll() {
				

				for (var i = 0; i < this.value.length; ++i) {
					this.$store.state.attachments.push(this.value[i]);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.file-list-view {
		overflow: hidden;

		& > input {
			position: absolute;
			left: -500px;
		}

		& > .file {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 40px;
			text-align: left;
			padding-left: 10px;
			margin-bottom: 10px;
			cursor: pointer;

			& > div {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
				}
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>